export default __webpack_public_path__ + "static/media/moleDAO.a5cfa709.mp4";